module.exports = __webpack_public_path__ + "static/media/check-solid.9f34147b.svg";